import React, { useState, useEffect } from 'react'
import attendanceServices from '../attendanceServices';
import MonthlyDateSelect from '../../../../../components/AppInput/MonthlyDateSelect';
import { useAppData } from '../../../../../context/AppDataContext';
import moment from 'moment';
import LeaveRequestStatus from './LeaveRequestStatus';

function ALLLeaveRequestList() {

    const {employeeDD, getMasterLabel, getDDDataById} = useAppData();

    const [filter,setFilter] = useState(null);

    const [leaveRequestList,setLeaveRequestList] = useState(null)

    const getLeaveRequestList = () =>{
        attendanceServices.getLeaveRequestListAll(filter).then(res=>{
            setLeaveRequestList(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }

    useEffect(()=>{
        getLeaveRequestList();
    },[filter])

    return (
        <div className='row'>
            <div className='col-md-12'>
                <h4 className='float-start'>Leave Request List</h4>
                <span className='float-end'><MonthlyDateSelect filter={filter} setFilter={setFilter} /></span>
            </div>
            <div className='col-md-12'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Employee</th>
                            <th>From</th>
                            <th>To</th>
                            <th>Day Count</th>
                            <th>Leave Type</th>
                            <th>Message</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {leaveRequestList?.map(leaveRequest=>
                            <tr key={leaveRequest.id}>
                                <td>{getDDDataById(employeeDD,leaveRequest.employeeId).label}</td>
                                <td>{moment(leaveRequest.startDate).format("LL")}</td>
                                <td>{moment(leaveRequest.endDate).format("LL")}</td>
                                <td>{ moment(leaveRequest.endDate).diff(moment(leaveRequest.startDate),"days")+1 }</td>
                                <td>{getMasterLabel("leave-type",leaveRequest.leaveType)}</td>
                                <td>{leaveRequest.message}</td>
                                <td>
                                    <LeaveRequestStatus leaveRequest={leaveRequest} callBack={getLeaveRequestList} />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
  )
}

export default ALLLeaveRequestList